import './components.css';

const VrijwilligersGezocht = () => {
    return (
        <div class="card">
            <h5 class="card-header">Gezocht</h5>
            <div class="card-body">
                <h5 class="card-title">Vrijwilliger Cafetaria</h5>
                <p class="card-text">Vrijwilliger voor cafetaria De Vliet te Zele gezocht.</p>
                <a href="https://www.zorgnetwerktrento.be/vrijwilliger-cafetaria-de-vliet" target="_top" class="btn btn-primary">
                    Bekijken
                </a>
            </div>
        </div>
    );
};
export default VrijwilligersGezocht;
